export const STATUS_CLASS_MAP: Record<string, string> = {
  ACTIVE: 'badgeSuccess',
  REVIEW_COMPLETED: 'badgeSuccess',
  IN_REVIEW: 'badgeInfo',
};

export const FORMAT_CLASS_MAP: Record<string, string> = {
  DOCX: 'badgeInfo',
};
